<div *ngIf="supplier">
  <h2>Company name : {{supplier.name | uppercase}}</h2>
  <div>
    <span>Location : </span>{{supplier.location}}
  </div>
  <div>
    <span>Sector : </span>{{supplier.sector}}
  </div>
</div>
<button (click)="goBack()">go back</button>